import {createBackendEditor, referenceActionData} from '../../form/ComponentEditor';
import OperationListEditor from './OperationListEditor';
import {ProductColumn, UnitFormatter} from "../../../utils/formatters";
import React, {Fragment} from "react";
import TextInput from "../../form/TextInput";
import {fullyear, halfyears, ifCompletedInput, months, quarters} from "../../../utils/other";
import SupplyOrderForm from "./Elements/SupplyOrderForm";
import StockEditor from "../../../components/editors/stockEditor";
import Button from "../../form/Button";
import RadioGroup from "../../form/RadioGroup";
import moment from "moment";
import PeriodInput from "../../form/PeriodInput";
import {connect} from "src/store";
import Modal from "../../layout/Modal";
import Portal from "../../layout/Portal";
import {paramsSerializer, UrlGenerator} from "../../../utils/request";
import {PriceView} from "../../classes/Price";

const sortable = true;
const filterable = true;

const sellerTypes = [
    {typename: "Kiadó", type: "publisher"},
    {typename: "Szállító", type: "supplier"},
];

class SupplyOrderEditor extends React.Component {

    state = {
        filtered: false,
        componentEditor: "SupplyOrder",
        filter: [
            {column: "preset", value: "SupplyOrder"},
            {column: "saved", value: 1}
        ],
        hidden: ["discount","pos","invoice","payment"/*, "source"*/],
        labels: {customer: " ", seller: "Partner"},
        disabled: ["customer"],
        actionButtons: [],
        pool: {
            sortBy: {field: "displayname", direction: "ASC"},
            orderBy: {field: "displayname", direction: "ASC"},
            selection: [],
            pageSize: 5,
            pageSizes: [5,10,15,20,50],
            component: "SupplyOrderPoolItem",
            view: ["id", "displayname", "barcode", "product_id", "saleprice", "listprice", "pickedqty", "OperationList_id", "OperationItem_id", "component_type", "component_id", "vat", "id","product_id","OperationList_id", "vat", "component_type", "component_id", ...PriceView("saleprice"), "saleprice", ...PriceView("listprice"), "listprice"]
        }
    };

    promisedSetState = (newState) => {
        return new Promise((resolve) => {
            this.setState(newState, () => {
                resolve()
            });
        });
    }

    constructor(props) {
        super(props);
    }

    getProps = () => {
        const props = {
            ...this.props,
            ...this.state,
        };
        const xtradata = (this.props.values.xtradata || {});
        const sellerType = xtradata.sellerType || sellerTypes[0].type;
        props.sellerType = <RadioGroup
            labelKey="typename"
            valueKey="type"
            objectValue={false}
            options={sellerTypes}
            value={sellerType}
            label={<Fragment>&nbsp;</Fragment>}
            saveChanges={(name, sellerType) => {
                props.setFormValues({...this.props.values, seller: null, xtradata: {...xtradata, sellerType}});
            }}
            {...props.getFieldProps("seller")}
        />;
        props.pool.columns = {
            "displayname": {
                ...ProductColumn("component_id"),
                width: 1,
            },
            "barcode": {
                header: 'Vonalkód',
                width: 1,
                sortable,
                filterable
            },
            /*[sellerType + "_qty"]: {
                header: 'Beszerzés',
                width: 1,
                sortable,
                filterable,
                renderer: (value, row) => UnitFormatter(value, row.unit),
                className: "unit"
            },*/
            "instock": {
                header: 'Készlet',
                width: 1,
                sortable,
                filterable,
                renderer: (value, row) => {
                    let editorList = null;
                    return <Fragment>
                        <a onClick={(e) => {
                            e && e.preventDefault();
                            editorList && editorList.focus();
                        }} >
                        {UnitFormatter(value || 0, row.unit)}
                        </a>
                        <Portal>
                            <StockEditor
                                gridid={null}
                                list={
                                    (props) =>
                                        <Modal
                                    size="large"
                                    ref={(e) => editorList = e}
                                    {...props}
                                    disabled={props.disabled || props.isLoading}
                                    buttons={[
                                        {
                                            text: "Bezárás",
                                            props: {color: "default", disabled: props.disabled || props.isLoading},
                                            onClose: true,
                                            onClick: async () => {
                                                try {
                                                    editorList && editorList.hide();
                                                } catch (e) {

                                                }
                                            }
                                        }
                                    ]}/>}
                                partner_id={this.props.till.pos.partner.partner_id}
                                product_id={row.product_id}
                            />
                        </Portal>
                    </Fragment>;
                },
                className: "unit"
            },
            "sold": {
                header: 'Eladás',
                width: 1,
                sortable,
                filterable,
                renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                className: "unit"
            },
            "pickedqty": {
                header: "Darabszám",
                width: 1,
                renderer: (value, row) => UnitFormatter(value, row.unit),
                sortable,
                filterable,
                className: "unit",
                editor:
                    (parent) =>
                        (props, value) =>
                            <TextInput type="number" name="pickedqty" label={false} focus value={value}
                                       onKeyDown={(e, field, value) => {ifCompletedInput(e) && parent.onEditorValueChange(props, value);}}
                                       onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
            },
        };
        /*if (sellerType === "publisher") {
            props.pool.columns[sellerType + "_sold"] = {header: '',
                width: 1,
                sortable,
                filterable,
                renderer: (value, row) => UnitFormatter(value, row.unit),
                className: "unit"
            };
        }*/
        let url = UrlGenerator();
        delete url.fragment;
        url.query = {
            option: 'OperationList',
            [props.componentConfig.idfield]: props.values[props.componentConfig.idfield],
            resptype: "excel"
        };
        props.actionButtons = [
            <Button tag="a" key="4" target="_blank" href={url.toString()} type="button" disabled={ props.isLoading || !props.values.id } color="primary" icon={{lib: "fa", name: "file-excel"}} className="pull-right">
                Export
            </Button>
        ];

        const year = xtradata.year || new Date().getFullYear();
        const period = xtradata.period || {};
        const periods = [
            {name: "Mai nap", from: moment().startOf('day').format("YYYY-MM-DD"), to: moment().endOf('day').format("YYYY-MM-DD")},
            ...quarters(year),
            ...halfyears(year),
            ...fullyear(year),
            ...months(year),
        ];
        if (periods.find((p) => p.from + "-" + p.to === period.from + "-" + period.to)) {
            //periods.push({name: "egyéb", from: null, to: null, disabled: true});
        } else {
            periods.push({name: "egyéb", ...period, disabled: true});
        }

        props.periodFilter = <PeriodInput
            periods={periods}
            value={Object.values(period)}
            label="Periódus"
            saveChanges={(field, value) => {
                let year;
                if (!value[0]) {
                    year = new Date().getFullYear()
                } else {
                    year = moment(value[0], "YYYY-MM-DD").format("YYYY") === moment(value[1], "YYYY-MM-DD").format("YYYY") ? moment(value[0], "YYYY-MM-DD").format("YYYY") : null;
                }
                props.setFormValues({...this.props.values, xtradata: {...xtradata, period: {from: value[0], to: value[1]}, year: year}});
            }}/>;

        props.pool.parameters = {};
        props.pool.reqparams = {};
        props.pool.filter = [{field: "isactive", value: 1}];
        if (period.from && period.to) {
            props.pool.parameters.period_from = period.from;
            props.pool.parameters.period_to =period.to;
        }
        if (props.values && props.values.seller) {
            props.pool.visible = true;
            props.pool.parameters.OperationList_id = props.values.id;
            props.pool.filter.push({field: sellerType, value: props.values.seller.partner_id});
            props.pool.parameters[sellerType] = props.values.seller.partner_id;
        } else {
            props.pool.visible = false;
        }
        props.filtered = this.state.filtered;
        if (this.state.filtered) {
            props.pool.filter.push({field: "pickedqty", operator: "not isnull"});
        }
        return props;
    }

    renderer = (componentProps) => {
        return <SupplyOrderForm {...componentProps} />;
    }

    render() {
        const props = this.getProps();
        return <OperationListEditor {...props} renderer={this.renderer} />;
    }

}

export default connect((state) => {
    return {
        till: state.app.till
    };
}, {})(createBackendEditor({
    componentName: "OperationList",
    WrappedComponent: SupplyOrderEditor,
    editor: "SupplyOrder",
    dirtyFlag: (values) => {
        return !parseInt(values.saved) && values.id;
    },
    props: {
        componentActions: async (action, data, params, componentConfig) => {
            params.preset = "SupplyOrder";
            data = await referenceActionData(data, componentConfig);
            return {action,data,params};
        }
    }
}));